var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContactUs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.59375 57.409V6.27264C0.59375 4.71014 1.15057 3.37302 2.2642 2.26128C3.37784 1.14953 4.71496 0.592714 6.27557 0.59082H51.7301C53.2926 0.59082 54.6307 1.14764 55.7443 2.26128C56.858 3.37491 57.4138 4.71203 57.4119 6.27264V40.3635C57.4119 41.926 56.8561 43.2641 55.7443 44.3778C54.6326 45.4914 53.2945 46.0473 51.7301 46.0454H11.9574L0.59375 57.409ZM11.9574 34.6817H34.6847V28.9999H11.9574V34.6817ZM11.9574 26.159H46.0483V20.4772H11.9574V26.159ZM11.9574 17.6363H46.0483V11.9545H11.9574V17.6363Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactUs);
export default __webpack_public_path__ + "static/media/contact-us.6f7a0bcdb80b3389b851b3310b2189b7.svg";
export { ForwardRef as ReactComponent };